export default __webpack_public_path__ + "img/check-circle.3c280462.svg";